// @flow

import React from 'react';
import Tappable from 'app/components/commons/Tappable';
import * as cssUtils from 'app/utils/cssUtils';
import colorUtils from 'color';
import useSheet from 'app/jss';
import t from 'app/utils/translate';
import Icon from 'app/components/commons/Icon';

type Props = {
  sheet: object,
  onDeleteRequest: () => void,
};

class FriendYouRequestPanel extends React.Component {
  props: Props;

  render() {
    const { sheet: { classes }, onDeleteRequest } = this.props;
    return (
      <Tappable className={classes.request} onTap={onDeleteRequest}>
        <Icon type="icon-remove-friend" />
        <span>{t('DELETE FRIEND REQUEST')}</span>
      </Tappable>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    request: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexGrow: 1,
      backgroundColor: theme.color.basis6,
      color: theme.color.basis4,
      transition: 'background-color 0.2s, color 0.2s',
      padding: theme.spacing.small,
      borderBottom: {
        color: colorUtils(theme.color.basis4)
          .alpha(0.2)
          .toString(),
        width: 1,
        style: 'solid',
      },
      '& > svg': {
        fontSize: 14,
        marginBottom: 2,
      },
      '& > *:not(:last-child)': {
        marginRight: 10,
      },
      ...cssUtils.hover({
        backgroundColor: colorUtils(theme.color.basis6)
          .darken(0.1)
          .hex(),
        color: colorUtils(theme.color.basis4)
          .darken(0.2)
          .hex(),
      }),
    },
  };
}

export default useSheet(applyStyles)(FriendYouRequestPanel);
